import React from "react";

import { Link } from "react-router-dom";
import translations from "./header-translations"

const Header = (props) => {

  return (
    <div className="site-header d-flex flex-column flex-md-row align-items-center p-3 px-md-4 border-bottom box-shadow">
      <h5 className="my-0 mr-md-auto font-weight-normal">
        <Link to={translations[props.lang].brand.url}>
          <span className="wordmark">Davoyage</span>
        </Link>
      </h5>
      <nav className="my-2 my-md-0 mr-md-3">
        <Link to={translations[props.lang].home.url} className="p-2 text-dark">
          {translations[props.lang].home.label}
        </Link>

        <Link to={translations[props.lang].quote.url} className="p-2 text-dark">
          {translations[props.lang].quote.label}
        </Link>

        <Link to={translations[props.lang].blog.url} className="p-2 text-dark">
          {translations[props.lang].blog.label}
        </Link>

        <a
          className="p-2 text-dark dropdown-toggle"
          id="dropdown06"
          href="/"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          {translations[props.lang].selected.label}
        </a>

        <div className="dropdown-menu" aria-labelledby="dropdown0">
          <a className="dropdown-item" href="/">{" "}{translations.fr.selected.label}</a>
          <a className="dropdown-item" href="/en/">{" "}{translations.en.selected.label}</a>
          <a className="dropdown-item" href="/ru/">{" "}{translations.ru.selected.label}</a>
        </div>
      </nav>
      <a
        className="btn cta"
        tabIndex="1"
        href="tel:+33660265336"
      >
        <svg
          className="svg-inline--fa fa-phone fa-w-16"
          aria-hidden="true"
          data-prefix="fas"
          data-icon="phone"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          data-fa-i2svg=""
        >
          <path
            fill="currentColor"
            d="M493.397 24.615l-104-23.997c-11.314-2.611-22.879 3.252-27.456 13.931l-48 111.997a24 24 0 0 0 6.862 28.029l60.617 49.596c-35.973 76.675-98.938 140.508-177.249 177.248l-49.596-60.616a24 24 0 0 0-28.029-6.862l-111.997 48C3.873 366.516-1.994 378.08.618 389.397l23.997 104C27.109 504.204 36.748 512 48 512c256.087 0 464-207.532 464-464 0-11.176-7.714-20.873-18.603-23.385z"
          ></path>
        </svg>
        <span>&nbsp;&nbsp; {translations[props.lang].phone}</span>
      </a>
    </div>
  );
};

export default Header;
